import React from 'react'

export interface HorizontalLineProps {}

export const HorizontalLine: React.FunctionComponent<HorizontalLineProps> =
	({}) => {
		return <hr className="horizontalLine" />
	}
